import * as angular from "angular";
import {IController} from "angular";

export class ProgramLocationsByTotalValuesTableComponent implements IController {

  accountId: string;
  locations: any;
  excludeLocationIds: any;
  onUpdateLocation: Function;
  onDeleteLocation: Function;
  onBulkEditLocation: Function;
  onCreateCustomer: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  };

  $onChanges(changes) {

  };


  /////////////////////////////////////////////////////////////////////



}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationsByTotalValuesTable', {
    require: {
      form: '^form'
    },
    bindings: {
      accountId: '<?',
      locations: '<',
      excludeLocationIds: '<?',
      onUpdateLocation: '&',
      onDeleteLocation: '&',
      onBulkEditLocation: '&',
      onCreateCustomer: '&'
    },
    template: require('./program-locations-by-total-values-table.html').default,
    controller: ProgramLocationsByTotalValuesTableComponent
  });
